import React from "react";
import { Row } from "components/Layout";
import { SubtleBadge } from "components/Badge";
import { CollapseLabel } from "components/Form";
import { useRuleFieldSchema } from "containers/Settings/RuleBooks/Schema/schemaContext";
import {
  getDataTypeByPath,
  normalisePathParts,
} from "containers/Settings/RuleBooks/Schema/schema";
import { useFieldValue } from "hooks";
import { Chip } from "components/Chip";

interface CriteriaHeaderProps {
  ruleInputPath: string | null;
  parentInputPath: string | null;
  hasPrerequisiteRule: boolean;
}

export function CriteriaHeader(props: CriteriaHeaderProps) {
  const { ruleInputPath, parentInputPath, hasPrerequisiteRule } = props;

  const schema = useRuleFieldSchema();

  const fullInputPath = normalisePathParts([parentInputPath, ruleInputPath]);

  const parentDataType = getDataTypeByPath(schema, parentInputPath);

  const dataType = getDataTypeByPath(schema, fullInputPath);

  const dataTypeName = dataType?.plural || ruleInputPath;
  const applySplits = useFieldValue("apply_splits") || false;
  const applyCriteriaFilterToSplits =
    useFieldValue("apply_criteria_filter_to_splits") || false;

  let label = fullInputPath;
  if (parentInputPath && hasPrerequisiteRule) {
    label = ruleInputPath
      ? `${dataTypeName} of the Prerequisite Rule's ${parentDataType.plural}`
      : `The Prerequisite Rule's ${parentDataType.plural}`;
  } else if (parentDataType) {
    label = ruleInputPath
      ? `${dataTypeName} of the Rule Set's ${parentDataType.plural}`
      : `The Rule Set's ${parentDataType.plural}`;
  } else if (dataType) {
    label = dataType.plural;
  }

  return (
    <Row>
      <div>
        <SubtleBadge>Criteria</SubtleBadge>
      </div>

      <Row alignCenter flexWrap>
        <CollapseLabel>{label}</CollapseLabel>
        {applySplits && <Chip>Apply Splits</Chip>}
        {applyCriteriaFilterToSplits && <Chip>Filter using Splits</Chip>}
      </Row>
    </Row>
  );
}
